"use client"

import IconChevronRight from '@/icons/chevron-right.svg'
import Link from "next/link";
import {MainMenuItemModel} from "@/components/custom/header/mainmenu/mainMenuItem";
import {usePathname} from "next/navigation";
import {dynamicLog} from "@/lib/logging/dynamic-logging";
import {IS_PROD} from "@/api/constants.cjs";
import {useSystemSettings} from "@/hooks/useSystemSettings";

interface SubMenuLinkProps {
    item: MainMenuItemModel;
    setSubactive?: (value: boolean) => void;
}

const SubMenuLink = ({ item, setSubactive }: SubMenuLinkProps) => {
    let pathname = usePathname();
    const { scopeSystem, unitSystem } = useSystemSettings();
    const replacements = ["search", "signIn", "projects", "accessories", "tools", "news", "productFinder"];

    replacements.forEach(r => {
        if(pathname.includes(r)) pathname = pathname.replace(r, "products")
    })

    const locale = pathname.split("/")[1];
    const path = pathname.split("/")[2] ?? "products";

    if (item.url && item.text) {
        return (
            <Link href={item.fullPath ? item.url : `/${locale}/${path}/${item.url}?scopeSystem=${scopeSystem}&unitSystem=${unitSystem}`} className='w-full cursor-pointer' passHref>
                <div className='flex flex-row items-center w-full'>
                    <span className='flex-1 cursor-pointer' onClick={() => setSubactive?.(false)}>{item.text}</span>
                    {item.children && item.children.length > 0 && (
                        <span className='flex-0'><IconChevronRight /></span>
                    )}
                </div>
            </Link>
        )
    }

    if (item.url === "" && item.text) {
        return (
            <div className='flex flex-row items-center w-full'>
                <span className='flex-1 cursor-default'>{item.text}</span>
                {item.children && item.children.length > 0 && (
                    <span className='flex-0'>
                        <IconChevronRight />
                    </span>
                )}
            </div>
        )
    }

    dynamicLog().error(`Missing name/label for product group ${item.id}`);
    return <>
        {!IS_PROD && (<span className='text-red-500 font-mono text-sm px-2 py-1 bg-yellow-100'>Missing Link Type/Label - {item.id}</span>)}
    </>
}

export { SubMenuLink }
